import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // 글로벌 이벤트 리스너 등록
    document.addEventListener('mobile-menu:toggle', this.toggle.bind(this))
    document.addEventListener('mobile-menu:show', this.show.bind(this))
    document.addEventListener('mobile-menu:hide', this.hide.bind(this))

    // 이미 연결된 컨트롤러가 있는지 확인
    if (window.mobileMenuController) {
      console.warn('Multiple mobile menu controllers detected')
    } else {
      // 글로벌 접근을 위해 컨트롤러 인스턴스 저장
      window.mobileMenuController = this
    }
  }

  disconnect() {
    // 이벤트 리스너 정리
    document.removeEventListener('mobile-menu:toggle', this.toggle.bind(this))
    document.removeEventListener('mobile-menu:show', this.show.bind(this))
    document.removeEventListener('mobile-menu:hide', this.hide.bind(this))

    // 글로벌 레퍼런스 제거
    if (window.mobileMenuController === this) {
      window.mobileMenuController = null
    }
  }

  toggle() {
    this.menuTarget.classList.toggle('hidden')
  }

  show() {
    this.menuTarget.classList.remove('hidden')
  }

  hide() {
    this.menuTarget.classList.add('hidden')
  }

  // GNB나 다른 컴포넌트에서 직접 호출할 수 있는 메서드들
  toggleFromAnywhere() {
    document.dispatchEvent(new CustomEvent('mobile-menu:toggle'))
  }

  showFromAnywhere() {
    document.dispatchEvent(new CustomEvent('mobile-menu:show'))
  }

  hideFromAnywhere() {
    document.dispatchEvent(new CustomEvent('mobile-menu:hide'))
  }
}

// 글로벌 헬퍼 함수들 - 어디서든 메뉴 컨트롤 가능
window.toggleMobileMenu = function() {
  document.dispatchEvent(new CustomEvent('mobile-menu:toggle'))
}

window.showMobileMenu = function() {
  document.dispatchEvent(new CustomEvent('mobile-menu:show'))
}

window.hideMobileMenu = function() {
  document.dispatchEvent(new CustomEvent('mobile-menu:hide'))
}
